<template>
    <app-layout title="Gebruikers">
        <template #header>
            <page-title title="Gebruiker aanmaken" />
        </template>

        <template #pageContent>
            <Form layout="columns" @submit="createUser(username)">
                <div>
                    <Input label="Gebruikersnaam" name="username" v-model="username" required  disabled v-if="form.auto" layout="vertical"/>
                    <Input label="Gebruikersnaam" name="username" v-model="form.username" required :error="form.errors.username" v-else layout="vertical"/>
                    <InputGroup layout="vertical">
                        <Input label="Gebruikersnaam automatisch genereren" name="auto" value="auto" type="checkbox" v-model="form.auto" :checked="form.auto"/>
                    </InputGroup>
                    <Input label="Voornaam" name="first_name" type="text"  v-model="form.first_name" required :error="form.errors.first_name" layout="vertical"/>
                    <Input label="Achternaam" name="last_name" type="text"  v-model="form.last_name" :error="form.errors.last_name" layout="vertical"/>
                    <Input label="Email" name="email" type="text" v-model="form.email" required :error="form.errors.email" layout="vertical"/>
                    <Input label="Functie" name="function" type="text"  v-model="form.function" :error="form.errors.function" required layout="vertical"/>
                    <Textarea label="Opmerking" name="comment" type="text"  v-model="form.comment" :error="form.errors.comment" layout="vertical" :maxlength="255"/>
                </div>
                <div class="flex flex-col">
                    <div class="pt-1.5">
                        <Label for="roles" label="Rollen" class="flex-none" id="label_roles"></Label>
                        <Multiselect
                            v-model="form.roles"
                            :options="roles"
                            mode="tags"
                            id="roles"
                            :searchable="true"
                            placeholder="selecteer een rol"
                            :closeOnSelect="false"
                        />
                        <Error :error="form.errors.roles" v-if="form.errors.roles" />
                    </div>

                    <div class="mt-5">
                        <Label for="permissions" label="Rechten" class="flex-none" id="label_permissions"/>
                        <Multiselect
                            v-model="form.permissions"
                            :options="permissions"
                            mode="tags"
                            id="permissions"
                            :searchable="true"
                            placeholder="selecteer een recht"
                            :closeOnSelect="false"
                        />
                        <Error :error="form.errors.permissions" v-if="form.errors.permissions" />
                    </div>

                    <div class="mt-3">
                        <Input label="In dienst op" name="activate_on" v-model="form.activate_on" layout="vertical" type="date"/>
                        <Input label="Uit dienst op" name="deactivate_on" v-model="form.deactivate_on" layout="vertical" type="date"/>
                        <InputGroup label="Status" :required="true" :error="form.errors.status" layout="vertical">
                            <Input label="Onmiddellijk actief" name="status" value="active" type="radio" v-model="form.status" required :checked="form.status == 'active'"/>
                            <Input label="Voorlopige gebruiker" name="status" value="pending" type="radio" v-model="form.status" required :checked="form.status == 'pending'"/>
                        </InputGroup>
                    </div>

                    <div class="flex mt-auto flex-wrap justify-end">
                        <Button
                            htmlType="a"
                            buttonClass="cancel"
                            title="Annuleren"
                            text="Annuleren"
                            :href="route('admin.users')"
                        />
                        <Button text="Gebruiker aanmaken" buttonType="submit" buttonClass="save"/>
                        <Button text="Controleer gebruikersnaam" buttonClass="search" @click="checkUsername(username)"/>
                    </div>

                </div>
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Button from '@/Components/Button.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'
import Form from '@/Components/Form.vue'
import InputGroup from '@/Components/InputGroup.vue'
import Label from '@/Components/Label.vue'
import Error from '@/Components/Error.vue'
import Textarea from '@/Components/Textarea.vue'

import { useForm } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Input,
        Select,
        Form,
        Multiselect,
        InputGroup,
        Label,
        Error,
        Textarea
    },
    props:[
        'roles',
        'permissions'
    ],
    data() {
        return {}
    },
    setup (props){
        let form = useForm({
            first_name: '',
            last_name: '',
            username: '',
            email: '',
            function: '',
            comment: '',
            activate_on: '',
            deactivate_on: '',
            roles: [],
            permissions: [],
            status: 'active',
            auto: true
        })

        function createUser(username){
            if(form.auto) form.username = username
            form.post('/admin/users')
        }

        function checkUsername(username){
            console.log('check');
            if(form.auto) form.username = username
            console.log(form.username);
            axios.get('/admin/users/username/' + form.username)
                .then(response => (
                    alert(response['data'])
                ))
        }

        return {
            state: store.state,
            ...store,
            form,
            createUser,
            checkUsername
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
        username(){
            var name = this.form.first_name.substring(0,1) + this.form.last_name.replace(/ /g,'')
            return  name.toLowerCase()
        }
    },
}

</script>
